import { NextApiResponse } from "next";
import { i18n } from "../../../../next-i18next.config";

export enum FeatureFlags {
  AftermarketQuoteMethod = "AftermarketQuoteMethod",
  C2CFinancing = "C2CFinancing",
  RoadwiseAccuTradeVehicleLookup = "RoadwiseAccuTradeVehicleLookup",
}

export async function revalidateStaticPagesForFlag(
  flag: FeatureFlags,
  res: NextApiResponse
) {
  let pages: string[] = [];

  switch (flag) {
    case FeatureFlags.AftermarketQuoteMethod:
      pages = ["/", "/warranty/quote"];
      break;

    case FeatureFlags.C2CFinancing:
      pages = [
        "/",
        "/about",
        "/contact",
        "/privacy-policy",
        "/terms-conditions",
        "/faq",

        "/warranty",
        "/warranty/quote",
        "/warranty/details",
        "/warranty/configure",
        "/warranty/contract",
        "/warranty/payment",
        "/warranty/complete",
        "/warranty/how-it-works",
        "/warranty/faq",

        "/financing",
        "/financing/vehicle-details",
        "/financing/personal-info",
        "/financing/confirm",
        "/financing/checklist",
        "/financing/how-it-works",
        "/financing/faq",

        "/profile",
        "/profile/address",
        "/profile/password",
        "/protection",
        "/protection/payments",
        "/my-financing",
      ];

      break;

    default: {
      throw new Error(`Unhandled flag: ${flag}`);
    }
  }

  if (pages.length === 0) return;

  const locales = [
    "",
    ...i18n.locales.filter((l) => l !== "zu").map((l) => `/${l}`),
  ];

  const localePages: string[] = [];

  for (let i = 0; i < pages.length; i += 1) {
    localePages.push(...locales.map((l) => l + pages[i]));
  }

  const sendBatch = async (batchPages: string[]) => {
    await Promise.all(batchPages.map((p) => res.revalidate(p.toLowerCase())));
  };

  // MaxListenersExceededWarning: Possible EventEmitter memory leak detected
  // `revalidate` pages by batch to fix warning until nextjs provides a way to
  // rebuild multiple pages.
  const batchSize = 10;

  const processBatch = async (index: number) => {
    if (index >= localePages.length) return;

    const batchPages = localePages.slice(index, index + batchSize);

    await sendBatch(batchPages);
    await processBatch(index + batchSize);
  };

  await processBatch(0);
}

export default {};
